import xlsx from 'xlsx';
import { IdNumberValidatorCL } from 'creditu-types/validators/id-number';
import { dateToFormatedString } from '@/infrastructure/date';

export class CreditToWalletReader {
  constructor(file) {
    this.file = file;
    this.workbookData = null;
  }

  async rows() {
    return new Promise((resolve, reject) => {
      const reader = new window.FileReader();

      reader.onerror = ev => {
        reader.abort();
        reject(ev);
      };

      reader.onload = e => {
        try {
          const fileData = e.target.result;
          const workbook = xlsx.read(fileData, { type: 'binary', cellDates: true });
          const rows = [];

          const payers = [
            {
              aplicar: { // Minvu
                sheetName: 'aplicar',
                columnA: 'DETALLE MONTOS A APLICAR',
                columnB: 'Suma de Total a Pagar UF',
                columnC: 'Suma de pagado $'
              }
            },
            {
              Inmobiliarias: {
                sheetName: 'Inmobiliarias',
                columnA: 'Rut',
                columnB: 'Nombre',
                columnC: 'Cuota',
                columnD: 'Monto',
                columnE: 'Inmobiliaria'
              }
            },
            {
              SeguroCesantia: {
                sheetName: 'SeguroCesantia',
                columnA: 'Rut',
                columnB: 'Nombre',
                columnC: 'Siniestro',
                columnD: 'Monto',
                columnE: 'Fecha'
              }
            }
          ];

          // const payerSheet = this.file.name.slice(0, -5);
          const payerSheet = workbook.Props.SheetNames[0];
          const payerSelected = payers.find(item => item[payerSheet]);

          if (payerSelected === undefined) {
            throw new Error('Invalid file content');
          }

          const sheetWork = payerSelected[Object.keys(payerSelected)].sheetName;
          const a1Value = workbook.Sheets[workbook.SheetNames.toString()].A1.v;
          const columnATitle = payerSelected[Object.keys(payerSelected)].columnA;
          const firstCreditRegister = sheetWork === 'aplicar' ? workbook.Sheets.aplicar.A4.v.length : workbook.Sheets[workbook.SheetNames.toString()].A2;

          // Valida que el archivo que se está procesando sea el archivo entregado a Demian y que tenga al menos 1 registro (Seguros | Inmobiliarias | Minvu)
          if (
            (payerSheet !== sheetWork) || (a1Value !== columnATitle) || (sheetWork === 'aplicar' ? firstCreditRegister !== 16 : firstCreditRegister === undefined)
          ) {
            throw new Error('Invalid file content');
          }

          this.workbookData = xlsx.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);

          this.workbookData.forEach(rawRow => {
            if (sheetWork === 'aplicar' && rawRow['DETALLE MONTOS A APLICAR'].length === 16) {
              const amount = rawRow.__EMPTY_1;
              const uf = rawRow.__EMPTY.toFixed(6);
              if (amount % 1 !== 0) {
                throw new Error('El archivo contiene valores de tipo decimal');
              }
              rows.push(
                {
                  companyOperationId: rawRow['DETALLE MONTOS A APLICAR'],
                  Uf: uf,
                  Monto: Number(amount)
                }
              );
            }
            if (sheetWork !== 'aplicar') {
              const idNumberValidatorCL = new IdNumberValidatorCL(); // Real Estate y Seguro de Cesantía

              // Seguro de censantía
              const ISOFormatDateWithSlash = 'YYYY-MM-DD';
              const formatDate = date => {
                return dateToFormatedString(date, ISOFormatDateWithSlash);
              };
              const amountWithDotsAndMoneySimbol = rawRow.Monto.toString().replace(/[$.]/g, ''); // Por si el monto viene con puntos y signo peso

              if (!idNumberValidatorCL.validate(rawRow.Rut)) {
                throw new TypeError(`${rawRow.Rut} no es un RUT válido, corrígelo e intenta nuevamente`);
              }

              const feeOrSinister = (payerSelected[Object.keys(payerSelected)].columnC === 'Cuota' ? 'Cuota' : 'Siniestro'); // Inmobiliaria o Seguro de censatía
              const unemploymentInsuranceOrRealEState = (payerSelected[Object.keys(payerSelected)].columnE === 'Inmobiliaria' ? 'Inmobiliaria' : 'Fecha'); // Inmobiliaria o Seguro de censatía

              rows.push(
                {
                  Rut: rawRow.Rut,
                  Nombre: rawRow.Nombre,
                  [feeOrSinister]: payerSelected[Object.keys(payerSelected)].columnE === 'Inmobiliaria' ? String(rawRow.Cuota) : String(rawRow.Siniestro),
                  Monto: Number(amountWithDotsAndMoneySimbol),
                  [unemploymentInsuranceOrRealEState]: payerSelected[Object.keys(payerSelected)].columnE === 'Inmobiliaria' ? rawRow.Inmobiliaria : formatDate(rawRow.Fecha)
                }
              );
            }
          });

          resolve(rows);
        } catch (error) {
          reader.onerror(error);
        }
      };

      reader.readAsBinaryString(this.file);
    });
  }
}
